import api from '@/plugins/apiService'

export default () => {
  const fetchEmailProfile = async () => {
    const payload = {
      component: 'email/profile',
    }
    try {
      const { data } = await api.findAll(`${payload.component}`)
      if (data.success && data.data) {
        return data.data
      }

      return null
    } catch (error) {
      return null
    }
  }

  const fetchOutlookEmail = async (folder, filter) => {
    const payload = {
      component: `email/client/${folder}`,
      filter: {
        sort: 'desc',
        ...filter,
      },
    }
    const resp = await api.findByParams(`${payload.component}`, { params: payload.filter })

    return resp
  }

  const fetchFolders = async () => {
    const payload = {
      component: 'email/client/folders',
    }

    try {
      const { data } = await api.findByParams(`${payload.component}`, { params: payload.filter })
      if (data.success && data.data) {
        return data.data
      }

      return []
    } catch (error) {
      return []
    }
  }

  const fetchEmailThread = async id => {
    const payload = {
      component: 'email/client/thread',
      objectId: id,
    }

    try {
      const { data } = await api.findAll(`${payload.component}/${payload.objectId}`)
      if (data.success && data.data) {
        return data.data
      }

      return []
    } catch (error) {
      return []
    }
  }

  const fetchModuleThread = async id => {
    const payload = {
      component: 'email/threads',
      objectId: id,
    }

    try {
      const { data } = await api.findAll(`${payload.component}/${payload.objectId}`)
      if (data.success && data.data) {
        return data.data
      }

      return []
    } catch (error) {
      return []
    }
  }

  const sendEmail = async payload => {
    const res = await api
      .save(`${payload.component}`, payload.object, { params: payload.filter })

    return res
  }

  const fetchLabel = async () => {
    const payload = {
      component: 'email/client/labels',
    }

    try {
      const { data } = await api.findByParams(`${payload.component}`, { params: payload.filter })
      if (data.success && data.data) {
        return data.data
      }

      return []
    } catch (error) {
      return []
    }
  }

  const emailLogout = async () => {
    try {
      const { data } = await api.delete('email/oauth/sign-out')

      return data
    } catch (error) {
      return error
    }
  }

  return {
    fetchEmailProfile,
    fetchOutlookEmail,
    fetchEmailThread,
    sendEmail,
    fetchFolders,
    fetchLabel,
    fetchModuleThread,
    emailLogout,
  }
}
